import Types from '../types';

const hideSidebar = payload => ({
  type: Types.HIDE_SIDEBAR,
  payload,
});

export default hideSidebar;
